import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation, Autoplay } from 'swiper/modules';
import NewsSection from './NewsSection';
import TransportSection from './TransportSection';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

const CombinedSection = () => {
  return (
    <div className="py-16 bg-gray/50">
      <Swiper
        modules={[Pagination, Navigation, Autoplay]}
        spaceBetween={0}
        slidesPerView={1}
        pagination={{ clickable: true }}
        navigation
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        className="combined-sections-slider"
      >
        <SwiperSlide>
          <NewsSection />
        </SwiperSlide>
        <SwiperSlide>
          <TransportSection />
        </SwiperSlide>
      </Swiper>
    </div>
  );
};

export default CombinedSection;